import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { QuoteProvider } from "./context/QuoteContext";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import QuotePage from "./pages/QuotePage";
import CoursesPage from "./pages/CoursesPage";
import NotificationsPage from "./pages/NotificationsPage";
import ContactPage from "./pages/ContactPage";
import MenuPage from "./pages/MenuPage";
import PrivacyPage from "./pages/PrivacyPage";

/* Scroll in cima ad ogni cambio di route (comportamento app-like). */
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <BrowserRouter>
            <QuoteProvider>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/catalogo" element={<CatalogPage />} />
                    <Route path="/preventivo" element={<QuotePage />} />
                    <Route path="/corsi" element={<CoursesPage />} />
                    <Route path="/notifiche" element={<NotificationsPage />} />
                    <Route path="/contatti" element={<ContactPage />} />
                    <Route path="/menu" element={<MenuPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </QuoteProvider>
        </BrowserRouter>
    );
}

export default App;
